import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiResponse } from './../models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class UploadHttpService {
  static uploadedFile = null;
  static uploadedFileForm = null;
  constructor(private http: HttpClient) { }

  upload(data: any): Observable<[]> {
    return this.http.post<ApiResponse>('/file', data).pipe(
      map(res => res.data.files)
    );
  }
}
